import startCase from 'lodash/startCase'

/**
 * APP MENU
 * {
 *   `entity`  used to check if current user has access to this
 *   `to`      routing path (default to /entity)
 *   `icon`    icon to shown in menu
 *   `text`    label to show in menu (default: ucfirst(entity))
 * }
 */
const menu = [
  {
    entity: 'dashboard',
    to: '/dashboard',
    icon: 'mdi-view-dashboard',
    text: 'Dashboard'
  },
  {
    entity: 'account',
    to: '/account',
    icon: 'mdi-account',
    text: 'Accounts'
  },
  {
    entity: 'protocol',
    to: '/protocol',
    icon: 'mdi-clipboard-text',
    text: 'Protocols'
  },
  {
    entity: 'protocol_has_site',
    to: '/protocol_has_site',
    icon: 'mdi-clipboard-list',
    text: 'Protocol Sites'
  },
  {
    entity: 'site',
    to: '/site',
    icon: 'mdi-hospital-building',
    text: 'Sites'
  },
  {
    entity: 'lab',
    to: '/lab',
    icon: 'mdi-test-tube',
    text: 'Labs'
  },
  {
    entity: 'point',
    to: '/points',
    icon: 'mdi-google-maps',
    text: 'Points'
  },
  {
    entity: 'shipment',
    to: '/shipments',
    icon: 'mdi-truck',
    text: 'Shipments'
  },
  
]

export default menu.map(item => ({
  type: item.type || 'core-drawer-link',
  entity: item.entity,
  action: item.action || 'read',
  to: item.to || `/${item.entity}`,
  icon: item.icon,
  text: item.text || startCase(item.entity),
  links: item.links ?
    item.links.map(l => ({
      entity: l.entity,
      action: l.action || 'read',
      to: l.to || `/${l.entity}`,
      icon: l.icon,
      text: l.text || startCase(l.entity),      
    })) : []
}))
